// frontend/src/api/services/wechatAuthApi.js
import sharedWechatAuthApi from '@shared-library/api/services/wechatAuthApi';

export default function(apiClient) {
  // 直接使用共享库中的微信认证API
  return sharedWechatAuthApi(apiClient);
}